export const getSelectedBpOptionIds = (product) => {
  return product._.selected_option_group?.bp_option_ids;
};
